// bit mask flag: values should be set 0,1,2,4,8,16, etc...
// Example for Css and Strings both, use 3.
export var CustomResources;
(function (CustomResources) {
  CustomResources[CustomResources["None"] = 0] = "None";
  CustomResources[CustomResources["Css"] = 1] = "Css";
  CustomResources[CustomResources["Strings"] = 2] = "Strings";
})(CustomResources || (CustomResources = {}));
export var AgeGroup;
(function (AgeGroup) {
  AgeGroup[AgeGroup["Undefined"] = 0] = "Undefined";
  AgeGroup[AgeGroup["MinorWithoutParentalConsent"] = 1] = "MinorWithoutParentalConsent";
  AgeGroup[AgeGroup["MinorWithParentalConsent"] = 2] = "MinorWithParentalConsent";
  AgeGroup[AgeGroup["NotAdult"] = 3] = "NotAdult";
  AgeGroup[AgeGroup["Adult"] = 4] = "Adult";
  AgeGroup[AgeGroup["MinorNoParentalConsentRequired"] = 5] = "MinorNoParentalConsentRequired";
})(AgeGroup || (AgeGroup = {}));
export var AuthenticationType;
(function (AuthenticationType) {
  AuthenticationType[AuthenticationType["MSA"] = 0] = "MSA";
  AuthenticationType[AuthenticationType["AAD"] = 1] = "AAD";
  AuthenticationType[AuthenticationType["Unauthenticated"] = 2] = "Unauthenticated";
})(AuthenticationType || (AuthenticationType = {}));